import React from 'react';
import { DropdownItem } from 'reactstrap';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { actionCreators } from '../store/Configurator';
import Helper from '../Helper';
import locale from '../Locale';

interface IProps {
	brands?: any[];
	toggleConfirmationModal(): void;
}
interface IState {
	brands: any[];
}
class Brands extends React.Component<IProps, IState> {
	constructor(props: IProps) {
		super(props);
		this.state = {
			brands: this.props.brands || [],
		};
	}
	setBrand(i: number) {
		const state = this.state;
		const theme = {
			logo: state.brands[i].style.logo,
			logotype: state.brands[i].style.logotype,
			title: state.brands[i].brandName,
			header: state.brands[i].style.title,
			color: state.brands[i].style.color,
			headerFontColor: state.brands[i].style.headerFontColor,
			brandPartnerId: state.brands[i].brandPartnerId,
			buttonColor: state.brands[i].style.buttonColor,
			buttonFontColor: state.brands[i].style.buttonFontColor,
			showExposedBanner: state.brands[i].style.showExposedBanner,
			exposedBannerText: state.brands[i].style.exposedBannerText,
			exposedBannerUrl: state.brands[i].style.exposedBannerUrl,
			exposedBannerColor: state.brands[i].style.exposedBannerColor,
			exposedBannerFontColor: state.brands[i].style.exposedBannerFontColor,
			configuratorFavicon: state.brands[i].style.configuratorFavicon,
			configuratorTitle: state.brands[i].style.configuratorTitle,
		};
		localStorage.setItem('selectedBrand', JSON.stringify(theme));
		this.props.toggleConfirmationModal();
	}

	componentDidMount() {
		if (!Helper.userAdmin() && !Helper.userInstaller()) {
			return;
		}
		const state: IState = this.state;

		if (this.state.brands.length === 0) {
			const url = '/brand';
			Helper.getData<any>(url)
				.then((data) => {
					if (data.Message && data.Message.length > 0) {
						(this.props as any).setError(locale.exception, data.Message);
						this.setState(state);
					} else {
						if (data && data.length > 0) {
							state.brands = data.map((item: any) => ({
								brandId: item.BrandId,
								brandPartnerId: item.BrandPartnerId,
								brandName: Helper.getLocalizedName(item.BrandName),
								style: {
									color: item.Style.BackgroundColor,
									headerFontColor: item.Style.HeaderFontColor,
									buttonColor: item.Style.ButtonColor,
									buttonFontColor: item.Style.ButtonFontColor,
									logo: item.Style.HeaderLogo,
									logotype: item.Style.HeaderLogotype,
									title: Helper.getLocalizedName(item.Style.HeaderText),
									showExposedBanner: item.Style.ShowExposedBanner,
									exposedBannerText: item.Style.ExposedBannerText,
									exposedBannerUrl: item.Style.ExposedBannerUrl,
									exposedBannerColor: item.Style.ExposedBannerColor,
									exposedBannerFontColor: item.Style.ExposedBannerFontColor,
									configuratorFavicon: item.Style.ConfiguratorFavicon,
									configuratorTitle: item.Style.ConfiguratorTitle,
								},
							}));
						}
						(this.props as any).setBrands(state.brands);
						this.setState(state);
					}
				})
				.catch((error) => {
					Helper.handleRequestError(error, locale.exception, (this.props as any).setError);
				});
		}
	}
	render() {
		const items = this.state.brands.map((item: any, i: number) => (
			<DropdownItem key={i} onClick={() => this.setBrand(i)}>
				{item.brandName}
			</DropdownItem>
		));
		return items;
	}
}
export default connect(
	(state: any) => state.configurator,
	(dispatch) => bindActionCreators(actionCreators, dispatch),
)(Brands);
